import { render, staticRenderFns } from "./QaDashboard.vue?vue&type=template&id=72d716f0&scoped=true&"
import script from "./QaDashboard.vue?vue&type=script&lang=js&"
export * from "./QaDashboard.vue?vue&type=script&lang=js&"
import style0 from "./QaDashboard.vue?vue&type=style&index=0&id=72d716f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d716f0",
  null
  
)

export default component.exports